module.exports = {
    //通用
    x_mh: "：",
    x_fh: "；",
    sys_name: 'ED Connect后台管理系统',
    sys_name2: 'ED Connect',
    sys_code: '© ED Connect 版权所有',
    pwd_login: '账号登录',
    input_code: "请填写账号",
    input_pwd: "请填写密码",
    btn_submit: '登录',
    reset_pwd: '重置密码',
    abt_me: '关于我们',
    flsm: '法律声明及隐私政策',
    call_me: '联系我们',
    sys_sn: '粤ICP备20039227号',
    about_link: 'https://www.baidu.com/',
    flsm_link: 'https://www.baidu.com/',
    call_me_link: 'https://www.baidu.com/',
    hezuo1_link: 'https://www.baidu.com/',
    hezuo2_link: 'https://www.baidu.cn/',
    hezuo3_link: 'https://www.baidu.cn/',
    wxm_cname: '小程序',
    wxm_ewm: '小程序二维码',
    op_ok: '操作成功',
    op_err: '操作失败',
    tips: '提示',
    warning: '警告',
    cancel: '取消',
    rfs: '刷新',
    select_role: '请选择角色',
    wellcom_wx: "欢迎使用 ED Connect 产品",
    unknown: '未知',
    pwd_err: "两次密码输入不一致",
    exit: '退出',
    new_password: '新密码',
    fix_password: '确认密码',
    save: "确认保存",
    coll_dir: '收藏夹',
    coll_add: '添加到收藏夹',
    coll_un: '暂无收藏记录',
    coll_func_err: '未找到需要收藏的页面',
    no_role: "您的账号无权限访问，请联系管理员",
    http_overtime: "本次操作由于网络超时失败,请稍后重试",
    server_error: "服务器连接失败",
    add_sub: '添加下级',
    info: '详情',
    cname: '名称',
    code: '编码',
    web_url: "网址",
    sort: '排序',
    icon: "图标",
    icon_color: "图标颜色",
    system_group: '系统组',
    cat_id: '分类',
    cdesc: '描述',
    cname_tw: '繁体名称',
    cdesc_tw: '繁体描述',
    cname_en: '英文名称',
    cdesc_en: '英文描述',
    input: '请输入正确内容',
    select: '请选择',
    root: "根",
    upd: '修改',
    mod_title: '功能模板',
    add: '新增',
    org_level: "组织级别",
    mod_cname: "模版名称",
    mod_cdesc: "模版描述",
    all: '全部',
    set_role: '配置角色',
    op: '操作',
    search_content: '搜索内容',
    prev: '上一页',
    next: '下一页',
    one_page: '一页',
    one_page_line: '条',
    add_role: '添加角色',
    select_func: "请选择功能",
    search_nodata: '查询完毕，没有找到对应的数据',
    incomplete: '您填写的资料不完整',
    clean_cache: "清理通用缓存",
    clean_com_setup: "单独清理全局配置缓存 Com Setup",
    clean_label: "清理",
    cache_manage: "缓存管理",
    today: '今天',
    yesterday: '昨天',
    last_days_3: '近3天',
    last_days_7: '近7天',
    last_days_30: '近30天',
    last_days_90: '近90天',
    curr_week: "本周",
    before_week: "上周",
    curr_month: "本月",
    before_month: "上一月",
    before_month3: "近3月",
    before_month4: "近4月",
    after_month: "下一月",
    curr_year: "本年",
    before_year: "上年",
    custom: "自定义",
    fm_date: '账期',
    rw_user: '做实人',
    rw_time: '做实时间',
    rw_user2: '审核人',
    rw_time2: '审核时间',
    week1: '周一',
    week2: '周二',
    week3: '周三',
    week4: '周四',
    week5: '周五',
    week6: '周六',
    week0: '周日',
    weeks: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
    x_dd: " =",
    x_yd: " ≈",
    x_xy: " <",
    x_dyd: " >=",
    list: '查询',
    export: '导出',
    insert_user: '添加用户',
    add_user: '创建用户',
    add_time: '创建日期',
    upd_user: '修改用户',
    upd_time: '修改时间',
    add_mod: '新增模板',
    upd_mod: '修改模板',
    set_mod_role: '配置模板角色',
    set_mod_role_func: '配置模板角色的功能',
    org_cid: "营业执照号码",
    org_cor: "公司负责人",
    org_mobile: "联系电话",
    cu_cname: "客服负责人",
    cu_mobile: "客服电话",
    admin_code: "平台内部管理员",
    cid_img_lnk: "营业执照照片",
    org_cdesc: "平台描述",
    org_location: "地区",
    status: '状态',
    org_addr: "详细地址",
    configure: "配置功能",
    del: "删除",
    confirm_delete: "确认删除吗？",
    role_cname: "角色名称",
    set_add: '配置',
    org_grade: '组织等级',
    org_contact: '联系人',
    cu_ser_time: '服务时间',
    build_img_lnk: '建筑图',
    logo_img_lnk: "logo 图片",
    org_cname: '门店名称',
    addrvalue: '地区选择',
    unit: '单位',
    price_unit: '元',
    f_unit: '分',
    z_unit: '张',
    hc_amt: '换卡费用',
    jb_show_diff: '交班时显示应收',
    order_remark1: '商品销售规则',
    order_remark2: '礼品兑换规则',
    day: '天',
    dep: '部门',
    dep_cname: "部门名称",
    remove: "移出",
    user_code: "用户账号",
    user_cname: "用户姓名",
    input_user: '请先查询用户',
    op_date: '操作日期',
    func_desc: '功能',
    add_user_code: '用户编码',
    org_code: '组织编码',
    org_name: '组织名称',
    use_role_cname: '使用角色',
    func_cdesc: '执行功能',
    select_org: '选择店铺',
    add_dep: '新增部门',
    img_lnk: "图片",
    scroll_mouse: '鼠标上下滚动可放大缩小',
    crop_pic: "裁剪",
    org_self: "本组织",
    add_role2: "新增角色",
    add_role_user: "添加已注册用户",
    order_auth_flag: '可下单授权',
    role_ts: '如果选择角色分类，当前角色总店可统一管理, 如果不选择角色分类，属组织内部私有, 总店无法统一管理。',
    role: '角色',
    role_cat: '角色分类',
    add_user_cname: '用户姓名',
    code_name: '编码 名称',
    add_sub_role: '添加下级角色',
    org: '组织',
    add_new_user: '新增用户',
    upd_new_user: '修改用户',
    down_role: '下级角色',
    birth: '生日',
    setup: '配置',
    sex: '性别',
    user_pwd: '密 码',
    cid_code: "身份证号",
    auth_code: '授权码',
    remove_self: '移出本组织',
    remove_org_all: '移出本组织及下级',
    confirm_remove: '确认移出吗？',
    org_prov: "省",
    org_city: "市",
    org_area: "区",
    org_addr_code: "地区编码",
    close: '关闭',
    no_pwd: "您的新密码和确认密码不一致",
    org_from1_cname: '总店名称',
    org_from2_cname: '区域名称',
    from2_yue_xd: '区域余额',
    yfee_xd: '有效天数',
    di_label: "的",
    org_down: '下级组织',
    choosePic: '选择图片',
    start_date: '开业时间',
    lng: '经度',
    lat: '纬度',
    curr_org: "当前组织",
    org_add_msg: '确定用当前语言添加下级组织吗',
    msg_mb: '短信模板',
    highset: '高级配置',
    show_day_qty: '收银机订单显示',
    select_lang: '选择语言',
    start_use: '启用',
    msg_mod_id: '模板ID',
    msg_sign: '签名',
    auto_send: '自动发送',
    hand_send: '手动发送',
    send_sm_from2: '通知区域会员',
    send_sm_fr: '通知门店会员',
    all_send_sm: '通知全部会员',
    un_start: '未开启',
    sen_txt: '发送',
    mod_content: '模板内容',
    param_qty: '参数数量',
    mod_content_place: '例：[sign]亲爱的大朋友们、小朋友们，明天就是我们的传统节日了，${p1}全体工作人员祝您${p2}快乐,万事顺意。',
    max_length_20: '限20个字符',
    send_msg: '发送短信通知',
    all_member: '所有会员',
    msg_from3: '短信通知(总店)',
    member_count: '(约{0}人)',
    check_auto_send: '查看自动发送',
    hand_msg_all: '手动通知全部',
    hand_msg_screen: '手动筛选通知',
    hand_msg_mobile: '指定手机号发送',
    limit_member_mobile: "多个手机号码，多个用英文逗号隔开",
    count_success: "计算成功",
    confirm_send: "确定发送吗？",
    bal: '余额',
    exp_date: "有效期至",
    delete_role: '删除角色',
    delete_succeed: '删除成功',
    check_msg_mb: '查看短信模板',
    cu_start_time: '例：上午09:00 - 下午18:00',
    undefined: '未定义',
    add_new_role: '新增下级角色管理',
    addrole: '添加且适应角色到同级别门店',
    saverole: '保存且适应到同级别组织',
    deleterole: '删除且适应到同级组织',
    confirm_deleterole: '确认删除且适应到同级组织吗',
    confirm_saverole: '确认保存且适应到同级组织吗',
    confirm_addrole: '确认添加且适应角色到同级别门店吗',
    self: '私有',
    default_self: '不选择为私有角色',
    toggle_admin: '切换{0}内部管理员',
    toggle_org_admin: '切换{0}组织管理员',
    old_org_admin: '旧内部管理员账号',
    new_org_admin: '新内部管理员账号',
    old_org_admin1: '旧组织管理员账号',
    new_org_admin1: '新组织管理员账号',
    key_setup: '秘钥配置',
    code_cname: '编码 姓名',
    user: '用户',
    ex_type: '扩展类型',
    cloud_service: '云服务',
    recharge: '充值',
    recharge_order: '充值订单',
    money_history: '余额历史',
    link_yfee: '年费续期',
    link_exwrap: '应用市场',
    link_msg: '购买短信包',
    org_admin_code: '组织管理员',
    link_wlsc: '物料市场',
    system_use: '平台可用',
    org0_use: '总店可用',
    org1_use: '区域可用',
    org2_use: '门店可用',
    yes: '是',
    no: '否',
    xy_dy: '≤',
    from_yue_xd: '总店余额',
    from3_yue_xd: '门店余额',
    call_add_user: '添加人员',
    name: '姓名',
    email: '邮箱',
    money_amt: '面值',
    hand_recharge: '人工充值',
    online_recharge: '在线充值',
    sure_recharge: '确认充值',
    select_goods: '请选择套餐',
    cf_recharge: '您确认需要充值吗？',
    save_start: "保存且继续添加",
    def_goodsrand: '定义商品品牌',
    def_vendor: '定义供应商',
    def_unit: '定义商品单位',
    add_def_unit: '新增商品单位',
    upd_def_unit: '修改商品单位',
    add_def_goodsrand: '新增商品品牌',
    upd_def_goodsrand: '修改商品品牌',
    add_goods_color: '新增商品颜色',
    upd_goods_color: '修改商品颜色',
    cal_type: "结算方式",
    cor_cname: "联系人",
    phone: '手机号码',
    addrs: "地址",
    addr_cname: "地址名称",
    add_def_vendor: '新增供应商',
    upd_def_vendor: '修改供应商',
    cor_name_en: "英文名",
    bs_cname: "业务员中文名",
    ac_cname: "会计中文名",
    vendor_tel: "公司电话",
    vendor_fax: "公司传真",
    vendor_email: "公司邮箱",
    org_fr_cname: "门店名称",
    ty: "通用",
    wx_pay: '微信支付',
    ali_pay: '支付宝支付',
    chk_read: '我已了解：充值的款项只可用于万向云端消费，且退款只能原路退回至付款账号。',
    pay_ok: '已支付完成',
    wx_scan: '请使用微信扫一扫支付',
    ali_scan: '请使用支付宝扫一扫支付',
    banci: '班次',
    def_banci: '定义班次',
    add_def_banci: '新增班次',
    upd_def_banci: '修改班次',
    banci_time_fr: '上班时间',
    banci_time_to: '下班时间',
    time_fr: '开始时间',
    time_to: '结束时间',
    tom_flag: '隔日',
    upimg: '上传图片',
    posimgs_ts: '提示：此图片最合适的大小为1366*768，最合适宽高比为0.56',
    view_img: '预览图片',
    def_dategroup: '定义日期集',
    add_def_dategroup: '新增日期集',
    upd_def_dategroup: '修改日期集',
    select_date: '日期选择',
    please_select_date: '请选择日期',
    date_qty: "内含天数",
    def_mtag: "定义会员标签",
    add_def_mtag: "新增会员标签",
    upd_def_mtag: "修改会员标签",
    def_gtag: "定义商品标签",
    add_def_gtag: "新增商品标签",
    upd_def_gtag: "修改商品标签",
    membertipscat_bolor: '标签颜色',
    def_rk: '定义快捷原因',
    add_def_rk: '新增快捷原因',
    upd_def_rk: '修改快捷原因',
    recharges0goods: '充值套餐',
    add_recharges0goods: '新增充值套餐',
    upd_recharges0goods: '修改充值套餐',
    package_cat: '套餐分类',
    package_cname: '套餐名称',
    package_code: '套餐编码',
    price: '单价',
    mj: '面值',
    yfees0goods: '年费续期套餐',
    add_yfees0goods: '新增年费续期套餐',
    upd_yfees0goods: '修改年费续期套餐',
    old_price: '原价',
    new_price: '现价',
    old_amt: '原金额',
    new_amt: '现金额',
    org_grade2: '店铺等级',
    msgs0goods: '短信包套餐',
    add_msgs0goods: '新增短信包套餐',
    upd_msgs0goods: '修改短信包套餐',
    msg_qty: '短信条数',
    exwraps0goods: '应用包套餐',
    add_exwraps0goods: '新增应用包套餐',
    upd_exwraps0goods: '修改应用包套餐',
    order_code: '订单号',
    order_code_old: '原订单号',
    three_code: '第三方订单号',
    amt: '金额',
    pay_cat: '支付方式',
    pay_status: '支付状态',
    pay_ok_time: '支付到账时间',
    back_status: '退款状态',
    back_ok_time: '退款到账时间',
    tot: '汇总',
    cancel_order: '您确定要取消当前订单吗',
    recharge_qty: '充值笔数',
    recv_amt: '收款金额',
    recv_cat: '收款类型',
    start_money_amt: '期初余额',
    recharge_money_amt: '充入余额',
    used_money_amt: '消费余额',
    end_money_amt: '结存余额',
    start_msg_qty: '期初短信余量',
    buy_msg_qty: '购买余量',
    used_msg_qty: '使用余量',
    end_msg_qty: '结存余量',
    rw: "做实",
    rw_true: "已做实",
    rw_false: "未做实",
    warning_rw: "您确定需要将当天账期做实吗",
    no_cal: '尚未计算',
    cal: '计算',
    print: '打印',
    pre_date: '前一天',
    after_date: '后一天',
    last_cal_time: '最后计算时间',
    tot_amt: '总营收',
    obg_cname: '项目名称',
    msg_bal: '短信余量一览',
    sum: '合计',
    bill_history: '结账历史',
    auto_code: '自动编码',
    imgs: '介绍图',
    imgs_pl: '温馨提示：介绍图建议上传宽度为800px的jpg图片，高度不限',
    mods: '适应模板',
    products0goods: '物料套餐',
    add_products0goods: '新增物料套餐',
    upd_products0goods: '修改物料套餐',
    qty: '数量',
    yfee_day_qty: '续期天数',
    recharges_order: '充值订单',
    overage_history: '余额历史',
    op_order_back: '退单',
    order_time: "下单时间",
    order_user: "下单人",
    confirm_back_order: '确认退单吗？',
    time_long: '时长',
    exwrap_cname: '应用名称',
    product_cname: '物料名称',
    set_org: '指定组织',
    move_type: '移动类型',
    move_amt: '移动余额',
    move_time: '移动时间',
    select_time_long: '请选择时长',
    add_time_long: '新增时长',
    bal_day_qty: '剩余天数',
    add_yfee: '续期',
    yfee_order: '续期订单',
    yfee_add: '确认续期',
    yfee_add_confirm: '确认续期吗？',
    package: '套餐',
    package_name: '套餐名称',
    pay_back_ok_time: '到账时间',
    vendor: '供应商',
    add_posimg: '新增收银机广告图',
    upd_posimg: '修改收银机广告图',
    msg_add: '购买短信包',
    del_posimg: '您确定要删除该收银机广告图吗',
    select_org_down: '选择下级组织',
    bal_msg_qty: '短信余量',
    buy_order: '购买订单',
    buy: '购买',
    sure_buy: '确认购买',
    sure_buy_comfirm: '确认购买吗？',
    qi: '起',
    qk_flag: '加急',
    tf_cat: '期望物流',
    free_tips: '温馨提示：当前物料货到付款，不包含运费。',
    bal_pay: '余额支付',
    tfc_cname: '快递公司',
    tf_status: '物流状态',
    tf_code: '快递单号',
    tfb: '接单',
    tfb_user: '接单人',
    tfb_time: '接单时间',
    tfc: '发货',
    q_tfc: '确认发货',
    tfc_user: '发货人',
    tfc_time: '发货时间',
    tfc_recv_time: '收货时间',
    chk_tfb: '您确定要接单吗',
    select_tfc: '选择快递公司',
    input_tf_code: '输入快递单号',
    p_upload_img: '请上传图片',
    p_upload_one_img: '请最少上传一张图片',
    type: '类型',
    ratio: '折',
    tags: '标签',
    up: '起',
    cdesc2: '介绍',
    group: '分组',
    def_group: '定义商品分组',
    add_def_group: '新增商品分组',
    upd_def_group: '修改商品分组',
    def_dir: '定义商品目录',
    add_dir1: '新增一级目录',
    upd_dir1: '修改一级目录',
    add_dir2: '新增二级目录',
    upd_dir2: '修改二级目录',
    goods_code_before: '货号前缀',
    goods_code_before_err: '货号前缀限两位，允许输入字母和数字，请填写正确',
    buy_has: '已购买',
    mv_msg_qty: '移动余量',
    goods_cat2: '商品分类',
    goods_type: '商品类型',
    dir_cname_1: '一级目录',
    dir_cname_3: '三级目录',
    add_dir3: '添加三级目录',
    upd_dir3: '修改三级目录',
    price_ratio: '购买单价折扣',
    ac_ratio: '积分兑换折扣',
    ac_price: '积分兑换价',
    member_price: '会员类型定价',
    def_area: '定义门店区域',
    add_def_area: '新增门店区域',
    upd_def_area: '修改门店区域',
    dev_brand: '设备品牌',
    add_dev_brand: '新增设备品牌',
    upd_dev_brand: '修改设备品牌',
    dev_types: '设备类型',
    add_dev_types: '新增设备类型',
    upd_dev_types: '修改设备类型',
    type_code: '类型编码',
    goods_cat: '关联套餐',
    dev_mods: '设备机型',
    add_dev_mods: '新增设备机型',
    upd_dev_mods: '修改设备机型',
    brand: '品牌',
    dev: '设备',
    goods_spec: "规格",
    goods_mod: "型号",
    people_qty: "容纳人数",
    lenght: "长",
    width: "宽",
    height: "高",
    space: "占地面积",
    mod_code: "机型编号",
    mod_reader: "收费口数量",
    card_no: '卡号',
    limit_use_qty: '可使用',
    unit_ci: '次',
    bal_use: '剩余',
    add2: '添加',
    only_fr: '指定门店',
    limit_use_qty2: '每日限使用次数',
    all_dev_flag: '全店通用',
    org_ty: '门店分区通用',
    only_dev: '指定设备',
    pl_dev_codes: "指定多个设备，用英文逗号隔开",
    js_3num: '建议3位数字，起始值001',
    js_4num: '建议4位数字，起始值0001',
    max_code: '最大号码',
    reget: '重新获取',
    max_code_ts: '号码以最大号码数字加1，提示重复请重新获取',
    not: '无',
    m_unit: '米',
    p_unit: '平方',
    base_membertype: '会员类型',
    add_base_membertype: '新增会员类型',
    upd_base_membertype: '修改会员类型',
    type_cname: '类型名称',
    level: '等级',
    forever: '无限期',
    limit_days: '有效时间',
    buy_add_days: "购买商品自动续期(天)",
    used_ac_up: "累计消费积分升级",
    timeout_void_days: "过期多久自动回收(天)",
    limit_date: '会员到期日期',
    buy_add_days2: '购买商品自动续期',
    timeout_void_days2: "过期多久自动回收",
    dev_dev1: '终端设备',
    add_dev_dev1: '新增终端设备',
    upd_dev_dev1: '修改终端设备',
    dev_vender_sn: '序列号',
    mod: '机型',
    select_devs: "请选择可用的设备",
    dev_ok: "有效设备",
    not_0: "0不启用",
    date_0: "0无期限",
    not_up_0: "0不参与升级",
    num: "整数",
    obj_code: "项目",
    orgarea: '门店区域',
    stock_line: "关联仓库",
    copy: '复制',
    dev_only_code: "唯一码",
    color: '颜色',
    df_lang: '默认语言',
    print_code: '云打印机编码',
    print_logo: '云打印机logo',
    print_auto: '自动打印小票',
    minute: '分钟',
    use_remark: '使用说明',
    remark: "备注",
    bar_code: '条码',
    goods_code: '货号',
    dir_id: '目录',
    chk_auth: '需授权',
    goods_code2: '商品编码',
    goods_code2a: '总店自营商品',
    goods_code2b: '总店联营商品',
    goods_code2_add: '新增总店自营商品',
    goods_code2_upd: '修改总店自营商品',
    goods_code2_copy: '复制总店自营商品',
    goods_code2b_add: '新增总店联营商品',
    goods_code2b_upd: '修改总店联营商品',
    goods_code2b_copy: '复制总店联营商品',
    goods_code2c_add: '新增门店自营商品',
    goods_code2c_upd: '修改门店自营商品',
    goods_code2c_copy: '复制门店自营商品',
    bar_code_pl: '请扫描或输入条码，如果是输入请按回车',
    att_ac: '附送积分',
    po_price: '采购价',
    trade: '商标',
    join_qty_flag: '虚拟库存',
    manu: '厂商',
    join_to: '关联到',
    start: '期初',
    move: '移动',
    end: '结余',
    operation_user: '操作人员',
    time: '时间',
    goods: '商品',
    goods_pl: '条码 货号 名称',
    base_price: '基价',
    org_price_only: '门店单独定价',
    com1_code: '统一单号',
    stock: '仓库',
    sn_cname: '单据凭证',
    inv_no: '发票号码',
    dtl: '明细',
    mv_qty: '移动数量',
    mv_price: '移动单价',
    mv_amt: '移动金额',
    snpoa: '采购入仓',
    snpoa_add: '新增采购入仓单',
    snpoa_auto_add_a: '智能生成总店自营商品采购入仓单',
    snpoa_auto_add_c: '智能生成门店自营商品采购入仓单',
    snpoa_upd: '修改采购入仓单',
    snpoa_dtl_add: '新增采购入仓单明细',
    snpoa_dtl_upd: '采购入仓单明细',
    note: '单据',
    note_date: '单据日期',
    dtl_add: '添加明细',
    dtl_insert: '插入明细',
    dev_doc_ts: '提示：优先级不能小于0，优先级值越小级别越高，填写后保存生效',
    sort_err: '排序不能为空',
    set_goods: '配置套餐',
    to: '到',
    copy_ts: '复制的状态为下架',
    search_goods: '搜索商品',
    search_goods_pl: '请搜索商品',
    stock_qty: '库存数量',
    line_id: '行号',
    row: '行',
    auto_add: '自增',
    chk_del: '您确定要删除吗',
    rw_note: '审核',
    vd_note: '作废',
    chk_note_rw: '您确定要审核当前单据吗',
    chk_note_vd: '您确定要作废当前单据吗',
    chk_note_recv: '您确定要签收当前单据吗',
    pro_stock: '配置仓库',
    stock_add: '新增仓库',
    stock_upd: '修改仓库',
    po_flag: '允许采购',
    po_recv_flag: '采购到货仓',
    stock_price: '成本单价',
    stock_amt: '成本金额',
    loss_amt: '亏损金额',
    org_fr: '从组织',
    org_to: '到组织',
    stock_fr: '从仓库',
    stock_to: '到仓库',
    old_qty: '原数量',
    old_cost_price: '原成本单价',
    old_cost_amt: '原成本金额',
    mv_cost_price: '移动成本单价',
    mv_cost_amt: '移动成本金额',
    new_qty: '现数量',
    new_cost_price: '现成本单价',
    new_cost_amt: '现成本金额',
    old: '原始',
    new: '当前',
    stock_sn: '库存移动',
    snpob: '采购退货',
    snpob_add: '新增采购退货单',
    snpob_upd: '修改采购退货单',
    snpob_dtl_add: '新增采购退货单明细',
    snpob_dtl_upd: '采购退货单明细',
    snmvb: '仓库转出',
    snmvb_add: '新增仓库转出单',
    snmvb_upd: '修改仓库转出单',
    snmvb_dtl_add: '新增仓库转出单明细',
    snmvb_dtl_upd: '仓库转出单明细',
    snmva: '仓库转入',
    snmva_dtl_upd: '仓库转入单签收',
    recv: '签收',
    snmdb: '调拨出仓',
    snmdb_add: '新增调拨出仓单',
    snmdb_upd: '修改调拨出仓单',
    snmdb_dtl_add: '新增调拨出仓单明细',
    snmdb_dtl_upd: '调拨出仓单明细',
    snmda: '调拨入仓',
    snmda_dtl_upd: '调拨转入单签收',
    code_pingz: '编码 凭证',
    snoh: '其它出仓',
    snoh_add: '新增其它出仓单',
    snoh_upd: '修改其它出仓单',
    snoh_dtl_add: '新增其它出仓单明细',
    snoh_dtl_upd: '其它出仓单明细',
    sncka: '仓库盘点',
    sncka_add: '新增盘点单',
    sncka_upd: '修改盘点单',
    sncka_lock: '锁定盘点表',
    chk_sncka_lock: '您确定要锁定当前盘点表吗',
    sncka_exp: '导出盘点表',
    sncka_dtl_upd: '盘点单明细',
    chk_qty: '盘点数量',
    lock_qty: '锁定数量',
    lock_price: '锁定单价',
    lock_amt: '锁定金额',
    seva_ok: '已保存',
    re_seva: '重新保存',
    goods_wrap: '组合商品',
    goods_awrap: '总店自营组合商品',
    goods_bwrap: '总店联营组合商品',
    goods_cwrap: '门店自营组合商品',
    fcolor: '文字颜色',
    bcolor: '背景颜色',
    limit_buy: '购买限制',
    limit_use: '使用限制',
    limit_time: '限时段',
    not_date_id: '排除日期集',
    buy_other_limit: '购买须知',
    buy_date_id: '可购日期集',
    buy_date_fr: '可购日期从',
    buy_date_to: '可购日期到',
    buy_limit_week: '可购星期',
    use_other_limit: '使用说明',
    rate_type: '周期',
    buy_limit_qty: '可购次数',
    date_tips: '1表示当天 2表示今天到明天23:59 ...',
    stockitem: '商品库存',
    sub_goods_cname: '子商品名称',
    sub_goods_ts: '提示：下架子商品不会影响已配置的子商品，如需移除已配置好的子商品请删除',
    sub_goods_add: '添加子商品',
    sub_goods_card_pl: '实物商品',
    add_err: '请勿重复添加',
    member_price_err: '会员类型尚未定价',
    recharge_to: '续期到',
    up_to: '升级到',
    use_date_id: '可使用日期集',
    use_date_fr: '可使用日期从',
    use_date_to: '可使用日期到',
    use_qty: '可用次数',
    limit_zero: '(0表示不限)',
    min_buy_qty: '最少购买数量',
    use_date_week: '可使用星期',
    df_vendor: '默认供用商',
    stock_min_qty: '库存数量低于',
    po_to_qty: '采购至数量',
    chk_auto_po: '您确定要智能生成采购单吗',
    auto_create_note: '智能为您生成单据',
    sub_item: '子单',
    snpop: '统一采购入仓',
    snpop_add: '新增统一采购入仓单',
    snpop_auto_add: '智能生成统一采购入仓单',
    snpop_upd: '修改统一采购入仓单',
    snpop_dtl_add: '新增统一采购入仓单明细',
    snpop_dtl_upd: '统一采购入仓单明细',
    snpop_item_print: '打印统一采购入仓单',
    rw_qty: '签收数量',
    rw_amt: '签收金额',
    gift_qty: '赠品数量',
    no_save_data: '没有需要保存的数据',
    diff_qty: '差异数量',
    diff_amt: '差异金额',
    ss: '实收',
    ss_qty: '实收数量',
    goods_wrap_add: '新增组合套餐',
    goods_awrap_add: '新增总店自营组合套餐',
    goods_awrap_upd: '修改总店自营组合套餐',
    goods_awrap_copy: '复制总店自营组合套餐',
    goods_bwrap_add: '新增总店联营组合套餐',
    goods_bwrap_upd: '修改总店联营组合套餐',
    goods_bwrap_copy: '复制总店联营组合套餐',
    goods_cwrap_add: '新增门店自营组合套餐',
    goods_cwrap_upd: '修改门店自营组合套餐',
    goods_cwrap_copy: '复制门店自营组合套餐',
    auto_count: '自动计算',
    po: '采购单',
    page: '页',
    pop: '采购计划',
    by_note: '按单据',
    by_sub_item: '按子单',
    by_org_fr: '按门店',
    by_vendor: '按供应商',
    by_dtl: '按明细',
    snmk: '商品加工',
    snmk_add: '新增商品加工单',
    snmk_upd: '修改商品加工单',
    snmk_dtl_add: '新增商品加工单明细',
    snmk_dtl_upd: '商品加工单明细',
    mk_goods: '成品',
    mk_sub_goods: '材料',
    mk_sub_goods_qty: '材料数量',
    mk_sub_add: '添加材料',
    print_qty: '打印张数',
    print_size: '打印尺寸',
    dates: '日期集',
    p_level: '优先级',
    online_status: '在线状态',
    member_up: '升级会员等级',
    member_recharge: '续期会员有效期',
    use_day: '可用天数',
    limit_buy2: '限购',
    goods_key: '套餐密钥',
    rate: '占比',
    set_rate: '价值平摊',
    one_buy_up: '单次满金额升到本级',
    acc_buy_up: '累计满金额升到本级',
    dir_exs: '规格参数',
    imgss: '图集',
    product_imgs: '产品图',
    product_imgs_pl: '温馨提示：产品图建议上传宽高为800px*800px的jpg或png图片',
    up_imgs_qty_err: '上传图片已达到数量限制',
    upload_err: "上传失败",
    max5z: "限5张",
    max6z: "限6张",
    max10z: "限10张",
    set_setup: "系列配置",
    set_sub: "子系列",
    set_code: "系列号",
    set_add_self_err: '请勿将自己加入到子系列',
    set_add_err: '当前商品已经加入其他系列，不可加入到当前系列',
    set_add_err2: '当前商品未设置规格且未设置颜色，不可加入系列',
    rn: '营收性质',
    goods_info: '商品详情',
    no_goods: '未找到商品',
    img_qty: '图片数量',
    doc: '文章',
    add_doc: '新增文章',
    upd_doc: '修改文章',
    doc_cdesc_pl: '填写介绍，将会以卡片的方式显示，否则以全屏背景的方式显示',
    doc_goods_pl: '填写后 点击会跳入商品详情',
    wxmp_flag: '线上销售仓',
    member_code: '会员编码',
    from_cname: '来源',
    err_cdesc: '失败原因',
    member_remark: '会员留言',
    r_goods_qty: '退款数量',
    r_money_amt: '退款金额',
    r_cost_amt: '退款成本金额',
    order_info: '订单详情',
    recv_cor_cname: '收货人',
    room_num: '门牌号',
    wait_send: '等待发货',
    tf_sendover: '已发货',
    krpano_url: '全景地址',
    pos_user_code: '收银员',
    down_banci: '强制交班',
    down_banci_ok: '强制交班成功',
    down_banci_sure: '您确定要强制交班吗',
    so_amt: '营收金额',
    jb_amt: '交班金额',
    order_add_org: '下单门店',
    ewm: '二维码',
    zhiwei: '职位',
    jingyan: '经验描述',
    zhineng: '岗位职能',
    task: '任务',
    cor_user: '负责人',
    timeout_day: '超时天数',
    status0_timeout: '未完工已超时任务',
    status0_timeout_plan: '未完工已超时计划',
    not_input: '可不填',
    tf_item_id: '发货单号',
    server_item_id: '售后单号',
    server_type: '售后类型',
    server_remark: '售后原因',
    server_back_list: '退货查询',
    server_no_rw_remark: '请输入拒绝原因',
    q_no_rw: '确认拒绝',
    bal_app_qty: '可申请次',
    date_id: '日期',
    start_amt: '期初营收',
    day_amt: '今日营收',
    end_amt: '累计营收',
    app_time: '申请时间',


    // init start
    zh_cname: '简体名称',
    tw_cname: '繁体名称',
    en_cname: '英文名称',
    user_zh_cname: '简体姓名',
    user_tw_cname: '繁体姓名',
    user_en_cname: '英文姓名',
    home: {
        school: '学校',
        add_school_user: '新增学校账户',
        teacher: '老师',
        add_teacherl_user: '新增老师账户',
        school_new_apply: '学校最新消息申请',
        check: '查看',
        teacher_new_apply: '老师最新消息申请',
        school_count: '现有学校数量',
        teacher_count: '现有老师数量',
        faculty_count: '现有教职工数量',
        job_count: '现有招聘职位',
    },
    page_title: {
        mail_template: "邮件模板",
        Sending_mail_records: "发送的邮件记录",
        Sending_mail_info: "发送的邮件记录详情",
        School_Application_Records: "学校申请记录",
        School_profile: "学校资料修改记录",
        School_Join_Us: "学校招聘广告",
        School_member_expire: "十四日内学校会费到期列表",
        teacher_member_expire: "七日内老师会费到期列表",
        teacher_Application_Records: "老师申请记录",
        teacher_profile: "老师资料修改记录",
        faculty_member_expire: "七日内教职工会费到期列表",
        faculty_Application_Records: "教职工列表",
        faculty_profile: "教职工资料修改记录",
        Information_platform: "平台信息分类",
        Basic_Website_Information: "网站基础信息",
        Site_footer_Settings: "网站页脚设置",
        footer_Setting_tow: "页脚二级目录设置",
        platform_role: "平台角色设置",
        home_ad_place: "首页广告管理",
        history_ad_place: "历史广告管理",
        ad_place: "广告位管理",
        ad_placeInfo: "广告位明细管理",
        tags: "标签分类管理",
        tags_item: "二级标签管理",
        newsUpdate: "平台消息更新",
        renewal: "续费套餐管理",
        blog: "平台教评心事管理",
        blog_ad: "教评心事广告管理",
        cent_list: "积分列表",
        wellness_ad: "健康广告管理",
        travel_ad: "Travel广告管理",
        wellness: "平台健康财富管理",
        travel: "平台Travel管理",
        white: "学校白名单管理",
        wealth_ad: "Wealth广告管理",
        tech: "诚意推介管理",
        tech_ad: "诚意推介广告管理",
    },
    school_record: {
        id: '学校ID',
        name: '学校名称',
        email: '邮箱',
        renewal_time: '续费日期',
        status: '状态',
    },
    faculty: {
        id: "教职工ID",
        name: '教职工名称',
        desc: '教职工简介',
        avartar: '教职工头像',
        change_profile: '教职工更改资料',
        join_time: '教职工加入时间',
        base_info: '教职工基本资料',
    },
    school: {
        recruit_title: '招聘标题',
        join_time: '学校加入时间',
        base_info: '学校基本资料',
        cn_name: '学校简体名称',
        tw_name: '学校繁体名称',
        en_name: '学校英文名称',
        login_account: '学校登入账号',
        desc: '学校简介',
        address: '学校地址',
        image: '学校图片',
        news: '学校最新消息',
        recruit: '学校招聘工作',
        work_number: '工作编号',
        recruit_type: '招聘类型',
        tag: '标签',
        job_title: '工作标题',
        job_desc: '工作简介',
        require: '工作要求',
        entry_date: '入职日期',
        work_period: '工作周期',
        salary_range: '薪资范围',
        salary_range2: '薪资',
        post_date: '发布日期',
        expiry_date: '有效日期',
        change_profile: '学校更改资料',
        last_modified: '最近更改',
        change_content: '更改内容',
        published_work: '学校发布的招聘工作',
    },
    teacher_record: {
        id: '老师ID',
        name: '老师姓名',
        alias: "别名",
        phone: "电话",
        email: '邮箱',
        renewal_time: '续费日期',
        status: '状态',
        last_changed_time: '最后更改时间​',
        change_profile: '老师更改资料',
        join_time: '老师加入时间',
        base_info: '老师基本资料',
        educational: "教育经验",
        workExperience: "工作经验",
        otherInfo: "其它资料",
        year: "年份",
        subject: "学科",
        desc: '老师简介',
        avartar: '老师头像',
    },
    cms_email: {
        id: "邮件ID",
        title: "邮件标题",
        name: "邮件名",
        addTime: "创建时间",
        content: "内容",
        send_user: "收件人",
        int_title: "请输入邮件标题",
        int_name: "请输入邮件名字",
        int_content: "请输入邮件内容",
        mail_end: '信尾',
        mail_dear: '信头',
        org_cname: '发件人',
    },
    infoPush: {
        name: "平台消息名称",
        content: "平台消息内容",
        cname_input: '请输入平台消息名称',
        content_input: '请输入平台消息内容',
    },
    job: {
        id: "招聘广告id",
        type: "招聘类别",
        name: "招聘职位名称",
    },
    table: {
        search: '搜索',
        reset: '重置',
    },
    Langue: {
        zn: '中文简体',
        tw: '中文繁体',
        en: 'English',
    },
    Info: {
        condition: "条款和条件",
        contactUs: "关于我们",
        footer_title: "页面页脚标题",
        order: '显示顺序',
        code: '编号',
        two_title: "二级目录标题",
        title: "页脚标题",
        url: "跳转连接",
        contentInput: '请输入条约内容',
        copyrightInput: '请输入版权内容',
        copyright: "版权",
        user_agreement: "用户协议",
        privacy_policy: "私隐政策",
        terms_us: "使用条款",
        homepage: "网站主页",
        homepageInput: '请输入网站主页',
        homeContactUs: "联系我们(主页)",
        contactUsInput: '请输入联系我们内容',
        description: '网站描述',
        keywords: '网站关键词',
        keywords_hint: 'keywords词语间要用英文“,”隔开',
    },
    Role: {
        name: "平台角色名称",
        cname_input: '请输入平台角色名字',
    },
    Ad: {
        name: "广告位名称",
        name_home: "首页广告名称",
        name_history: "历史广告名称",
        name_info: "广告位明细名称",
        cname_input: '请输入广告位名称',
        url_link_input: '请输入跳转连接',
        beginDate_input: '请输入发布时间',
        endDate_input: '请输入下架时间',
        name_info_input: '请输入广告位明细名称',
        name_home_input: '请输入首页广告名称',
        name_history_input: '请输入历史广告名称',
        code_input: '请输入广告位编码',
        beginDate: '发布时间',
        endDate: '下架时间',
    },
    Tags: {
        name: "标签分类名称",
        // names: "二级标签名称",
        names: "标签名称",
        wi: "权重"
    },
    renewal: {
        name: "续费套餐名称",
        cname_input: "请输入续费套餐名称",
        price_input: '请输入单价',
        days_input: '请输入有效天数',
    },
    contact_name: '联系人',
    contact_mobile: '联系电话',
    detail: '详情',
    reviewing: '待审核',
    reviewed: '已审核',
    review_overdue: '已过期',
    trans_history_record: '交易历史记录',
    pwd_admin: '密码管理',
    release_status: '招聘状态',
    look_count: '查看人数',
    deliver_count: '投递人数',
    last_update_time: '最后更新时间',
    force_off_shelf: '强制下架',
    release: '发布中',
    unRelease: '未发布',
    vip_payment_plan: '会费缴费计划',
    vip_due_time: '会费到期时间',
    off_shelf: '下架',
    confirm_off_shelf: '确定要下架吗?',
    apply_agree: '确认申请',
    confirm_apply_agree: '确定确认申请吗?',
    apply_reject: '拒绝申请',
    confirm_apply_reject: '确定拒绝申请吗?',
    topic: '话题',
    modify: '修改',
    edit: '编辑',
    revert: '回滚',
    force_revert: '强制回滚',
    confirm_revert: '确认要回滚吗?',
    text_check_res: '关键字检测结果',
    new_update: '最新更改',
    abnormal: '异常',
    not_abnormal: '无异常',
    approval_refused: '审批拒绝',
    activate: '激活',
    nonactivated: '未激活',
    no_server_rw_remark: '拒绝原因不能为空',
    back: '返回',
    salary: '工资',
    company: '公司',
    upload_file_name: '上传资料文件名',
    click_view: '点击查看',
    payment: '缴费方式',
    publisher: '发布者',
    sure: '确认',
    improve_information: '请完善资料！',
    website_logo: "Logo",
    content: "内容",
    hotline: "热线",
    fax: "传真",
    sort_input: "请输入排序顺序",
    score_input: "请输入权重",
    addressInput: '请输入地址',
    emailInput: '请输入邮箱',
    faxInput: '请输入传真',
    hotlineInput: '请输入热线',
    userAgreementInput: '请输入用户协议内容',
    privatePrivacy: '请输入隐私策略内容',
    termsUse: '请输入使用条款内容',
    enabled: '启用',
    amount: '总数',
    ID: "账号",
    PWD: "密码",
    isJump: "是否跳转",
    external_link: "是否外部链接",
    Whether_by: "是否轮播",
    title: "标题",
    brief: "简介",
    isHome: "是否首页",
    content_input: "请输入内容",
    title_input: "请输入标题",
    brief_input: "请输入简介",
    preserve: "保存",
    system_layout: "系统设置",
    Integral_set: "积分设置",
    Welcome_reward: "迎新奖赏",
    Credit_time: "积分过期时间/天,365倍数为按N年时间",
    Integral_transform: "N个积分转换1元金额等值",
    PointInt: "每消费1元添加N积分",
    PresentExp: "赠送积分",
    time_fr_input: '请输入开始时间',
    time_to_input: '请输入结束时间',
    PresentExp_input: '请输入赠送积分',
    effective_time_input: '请输入积分过期时间',
    equivalent_value_input: '请输入分转换金额转换',
    Integral_transform_input: '请输入消费添加积分',
    cent: {
        time: "交易时间",
        expire_time: "过期时间",
        integral: "积分",
        employ: "积分使用／增加",
        name: "教评心事广告名称​",
        name_input: "请输入教评心事广告名称​",
        cent_expire_time: "积分过期日期",
    },
    wellness: {
        name: "健康广告名称​",
        name_input: "请输入健康广告名称​",
    },
    wealth: {
        name: "财富广告名称​",
        name_input: "请输入财富广告名称​",
    },
    travel: {
        name: "Travel广告名称​",
        name_input: "请输入Travel广告名称​",
    },
    alumni: '校友',
    parent: '家长',
    student: '学生',
    Details_pictures: '详情图片',
    photo_tip: '推荐图片大小为',
    and: '或',
    shop_welcome_set: '购物迎新设置',
    amount_bonus: '奖励金额',
    member_day: '新会员注册天数',
    Reward_ratio: '奖励倍数',
    amount_bonus_input: '请输入奖励金额',
    member_day_input: '请输入新会员注册天数',
    Reward_ratio_input: '请输入奖励倍数',
    Reward_Type: '奖励类型',
    onTop: '是否置顶',
    product_ids: '关联商品',
    wellness_ids: '关联健康',
    product_ids_input: '请输入关联商品Id',
    wellness_ids_input: '请输入关联健康Id',
    travel_ids: '关联旅游',
    travel_ids_input: '请输入关联旅游Id',
    noMore: '没有更多了',
    email_error: "邮箱格式不正确",
    WinmailTitle: '系统邮箱配置',
    mail_code: '邮箱类型',
    mail_user_name: '邮箱账号',
    mail_password: '授权码',
    mail_per_day: '1天发送总量',
    mail_per_hour: '1小时发送总量',
    mail_per_minute: '1分钟发送总量',
    default_status: '是否默认',
    mail_code_input: '请选择邮箱类型',
    mail_user_name_input: '请输入邮箱账号',
    mail_password_input: '请输入授权码',
    mail_per_day_input: '请输入1天发送总量',
    mail_per_hour_input: '请输入1小时发送总量',
    mail_per_minute_input: '请输入1分钟发送总量',
    multiples: '是否多选',
    concept: '本会理念',
    author: '作者',
    author_input: '请输入作者',
    thinkTitle: '冷思热话管理',
    think_ids: '关联冷思热话',
    think_ids_input: '请输入关联冷思热话Id',
    video_input: '请输入youtube视频网址',
    videoURL: '视频网址',
    Teaching_Staff: '教学人员',
    Non_Teaching_Staff: '非教学人员',
    static: "静态",
    rotation: "轮播",
    detailed_page: "详情页",
    Copy_language: "复制到其他语言",
    NotSuitable: "不适用",
    SalaryType: "薪金类别",
    RecordData: "资料提交记录",
    type_input: '请选择类型',
    techCentName: '诚意推介广告名称​',
    techName_input: "请输入诚意推介广告名称​",
}



// WEBPACK FOOTER //
// ./src/utils/lang/zh-CN.js